import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { url as productUrl } from '../../models/product';
import { previewVariant } from './actions';
import { RadioList, RadioListItem } from 'scy/RadioList';
import { secondary } from 'scy/text/styles.mod.scss';
import { strikethrough } from 'scy/utils.mod.scss';

class ProductVariants extends React.Component {
  select(variant) {
    const currentProduct = this.props.product;
    this.props.previewVariant(variant, currentProduct);
    const path = productUrl(variant);
    this.props.history.replace(path);
  }

  componentDidMount() {
    this._checkValidVariant();
  }

  componentDidUpdate() {
    this._checkValidVariant();
  }

  _checkValidVariant() {
    const currentProduct = this.props.product;
    const variants = currentProduct.volume_variants || [];
    const currentProductInVariants = variants.some(
      v => v.sku_id === currentProduct.sku_id
    );
    if (variants.length && !currentProductInVariants) {
      this.select(variants[0]);
    }
  }

  render() {
    const currentProduct = this.props.product;
    const variants =
      currentProduct.volume_variants ||
      (currentProduct.sku_id ? [currentProduct] : []);
    const sortedVariants = variants.sort((v1, v2) => v1.price - v2.price);
    const hasAddress = !!(this.props.address || this.props.zip);

    return (
      <RadioList className={this.props.className}>
        {sortedVariants.map(product => (
          <ProductVariant
            product={product}
            hasAddress={hasAddress}
            checked={currentProduct.sku_id === product.sku_id}
            onChange={() => this.select(product)}
            key={currentProduct.sku_id + '-' + product.sku_id}
            selectedIngredients={this.props.selectedIngredients}
          />
        ))}
      </RadioList>
    );
  }
}

function ProductVariant({
  product,
  hasAddress,
  checked,
  selectedIngredients = [],
  onChange
}) {
  const { soldout, price, volume, free_shipping } = product;
  const unavailable = hasAddress && !price;
  const disabled = soldout || unavailable;
  return (
    <RadioListItem
      name="product-variant"
      id={`product-variant-${product.sku_id}`}
      onChange={disabled || checked ? () => {} : onChange}
      checked={checked}
      disabled={disabled}
      title={volume}
      subtitle={
        soldout
          ? 'Sold Out'
          : unavailable
          ? 'Currently Unavailable'
          : free_shipping
          ? 'Free Shipping'
          : null
      }
      highlightSubtitle={free_shipping}
      aside={
        <PriceDisplay
          product={product}
          hasAddress={hasAddress}
          checked={checked}
          selectedIngredients={selectedIngredients}
        />
      }
    />
  );
}

function PriceDisplay({
  product,
  hasAddress,
  checked,
  selectedIngredients = []
}) {
  if (!product.price) return null;

  let priceDisplay = product.priceDisplay;
  if (checked && selectedIngredients.length) {
    priceDisplay = selectedIngredients
      .reduce((sum, i) => {
        const product = i.selected || {};
        return (product.price || 0) + sum;
      }, 0)
      .toFixed(2);
  }

  return (
    <>
      <PricePrefix
        hasAddress={hasAddress}
        regularPriceDisplay={product.regularPriceDisplay}
        priceDisplay={priceDisplay}
      />
      <span> ${priceDisplay}</span>
    </>
  );
}

function PricePrefix({ hasAddress, regularPriceDisplay, priceDisplay }) {
  if (!hasAddress) return <span>From</span>;
  if (!!regularPriceDisplay && regularPriceDisplay !== priceDisplay) {
    return (
      <span className={`${secondary} ${strikethrough}`}>
        ${regularPriceDisplay}
      </span>
    );
  }
  return null;
}

export default withRouter(
  connect(
    state => ({
      address: state.address.address,
      zip: state.address.zip,
      selectedIngredients: state.product.selectedIngredients
    }),
    { previewVariant }
  )(ProductVariants)
);
